module.exports = __webpack_public_path__ + "media/bootstrap-icons/sunrise-fill-30fbaedb.svg";